<template slot="inview" slot-scope="{ action, hasEnter, hasLeave }">
    <div class="Package animateMe" v-inview:class="['animateShow']">
        <div class="Package__inner">
            <div class="Package__titleCover">
                <h1 class="title">{{data.data.service_name}}</h1>
            </div>
            <div class="Package__textCover">
                <ul class="list">
                  <li v-for="(feature, index) in data.data.features_list" :key="index">
                    <h4 v-if="feature.feature_title">{{ feature.feature_title }}</h4>
                    <prismic-rich-text v-if="feature.feature_details" :field="feature.feature_details"/>
                  </li>
                </ul>
            </div>
            <div class="Package__footerCover">
              <div class="Package__priceCover">
                <div class="Package__price">
                      <h4 class="Package__addOnTitle"> </h4>
                        <span class="money" v-if="!data.data.compare_at_price">${{data.data.price}}</span>
                        <span class="money--discount" v-if="data.data.compare_at_price">
                            <span class="before">${{data.data.compare_at_price}}</span>
                            <span class="after money">${{data.data.price}}</span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="Package__addOnCover" v-if="addonServices.length">
                <h4 class="Package__addOnTitle"> Extras </h4>

                <div class="Package__addOnTable">
                    <div v-for="addonService in addonServices" :key="addonService.id">
                      <div class="flex">
                        <div class="Package__addOnCellLeft">
                          <h5>
                            <span v-html="addonService.data.service_name" />
                            <v-tooltip bottom v-if="addonService.data.add_on_description">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="ml-1" v-bind="attrs" v-on="on">mdi-information</v-icon>
                              </template>

                              <span v-html="addonService.data.add_on_description"></span>
                            </v-tooltip>
                          </h5>
                          <h6>
                            <del v-if="addonService.data.compare_at_price">${{ addonService.data.compare_at_price }}</del>
                            <ins>${{addonService.data.price}}</ins>
                          </h6>
                        </div>
                        <div class="Package__addOnCellRight">
                          <v-checkbox v-model="selectedAddons" :disabled="!addonService.data.stripe_price_id" :value="addonService.data.stripe_price_id"></v-checkbox>
                        </div>
                      </div>
                      <div>
                        <div>
                          <ul class="list">
                            <li v-for="(feature, index) in addonService.data.features_list" :key="index">
                              <h4 v-if="feature.feature_title">{{ feature.feature_title }}</h4>
                              <prismic-rich-text v-if="feature.feature_details" :field="feature.feature_details"/>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="Package__footerCover" v-if="selectedAddons.length">
              <div class="Package__priceCover">
                <div class="Package__price">
                      <h4 class="Package__addOnTitle"> Total price: </h4>
                        <span class="money" v-if="!data.data.price">${{data.data.price}}</span>
                        <span class="money--discount" v-if="data.data.price">
                            <span class="after money">${{data.data.price + this.calculateAddOn(selectedAddons, addonServices) }}</span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="Package__footerCover">
              <div class="Package__footerButton">
                <v-btn color="info" block depressed @click="showNextStep(data.data.stripe_price_id)">Book it now</v-btn>
              </div>
            </div>
        </div>

              <!-- {{ addonServices }} -->

    </div>
</template>

<script>
import ServiceItemMixin from './service-item-mixins'

export default {
  name: 'Package',
  props: [
    "data",
    "number",
    "selectedType"
  ],
  mixins: [ServiceItemMixin],
  data () {
    return {
      selectedAddons: []
    }
  },
  methods: {
    showNextStep (event) {
      this.$emit('onSubmit', { items: [this.data.data.stripe_price_id, ...this.selectedAddons] })
    },
    calculateAddOn(selected, services) {
      let result = 0
      for (let index = 0; index < selected.length; index++) {
        const element = selected[index];
        services.filter(function(numb){
          result += numb.data.stripe_price_id == element ? numb.data.price : 0
        }) 
      }
      return result
    }
  },
  computed: {
    addonServices () {
      return this.serviceProducts.filter(({ data }) => data.depends_on_service.id === this.data.id).sort((a,b) => a.data.order - b.data.order)
    }
  },
  mounted () {}
}
</script>
<style scoped>

.maxContainer {
  max-width: 1280px;
  margin: 0 auto;
}

.responiveImage {
  display: block;
  width: 100%;
}
.list {
  list-style: none;
  padding: 0;
}

.list li {
  margin-bottom: 15px;
}

.list li:last-child {
  margin-bottom: 0;
}

.Package {
    max-width: 100%;
    width: 100%;
    padding: 10px;
}
@media (min-width: 768px) {
  .Package {
      /* max-width: 50%; */
      width: 100%;
      padding: 10px;
  }
}
@media (min-width: 960px) {
  .Package {
      /* max-width: 33%; */
      width: 100%;
      padding: 10px;
  }
}

.Package__inner {
    padding: 0;
    border: 1px solid #191340;
}
.Package__titleCover {
    background-color: #191340;
    padding: 16px;
    color: white;
    text-align: center;
}

.Package__textCover {
  padding: 16px 16px 0;
}
@media (min-width: 768px) {
  /* .personalStatementPage .Package__textCover {
    min-height: 420px;
  } */
}

.Package__addOnCover {
    padding: 16px;
    border-top: 1px solid #191340;
}

.Package__addOnTitle {
    display: inline-block;
    font-size: 24px;
}

.Package__addOnTable {
    width: 100%;
}

@media (min-width: 768px) {
  .Package__addOnTable {
    width: 100%;
    display: flex;
    margin: 0 -16px;
  }
  .Package__addOnTable > div {
    width: 33.333%;
    padding: 16px;
  } 
  .Package__addOnTable > div + div {
    border-left: 1px solid #191340;
    
  }
}

.Package__addOnCellLeft {
    width: calc(100% - 30px);
    font-size: 20px;
}

.Package__addOnCellRight {
    width: 30px;
    text-align: right;
}

.Package__footerCover {
    padding: 0 16px 16px;
    /* border-top: 1px solid #191340; */
    display: flex;
    justify-content: end;
}
.Package__footerCover button {
    background-color: #191340!important;
    border-color: #191340!important;
}
.Package__footerButton {
  /* max-width: 100%; */
  width: 100%;
}
@media (min-width: 768px) {
  .Package__footerButton {
    max-width: 320px;
    margin-left: auto;
  }
  
}

.Package__price {
    font-size: 24px;
    font-weight: bold;
}
.Package__price .before {
    font-size: 20px;
    text-decoration: line-through;
}

.flex {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Services/PackageCard.vue